import React from 'react';
import {
    isBlank,
    orDash,
    buildDetailsText,
    renderWithDetails,
    renderTableDate,
} from '../../Components/GenericTable/cellFormatters';
import StatusChip from '../../Components/StatusChip';

const ROLE_LABELS = {
    superadmin: 'Super Admin',
    customeradmin: 'Customer Admin',
    csmadmin: 'CSM',
    projectadmin: 'Project Admin',
    gcologist: 'GCologist',
    learner: 'Learner',
};

export function formatRole(role) {
    if (isBlank(role)) return orDash(role);
    const value = String(role);
    return ROLE_LABELS[value.toLowerCase()] || value.charAt(0).toUpperCase() + value.slice(1);
}

export function customerNames(row) {
    return (Array.isArray(row.customers) ? row.customers : [])
        .map((customer) => customer?.name)
        .filter((name) => !isBlank(name));
}

export function buildUserDetails(row) {
    return buildDetailsText([
        ['Location', row.location],
        ['Country', row.country],
        ['Job title', row.job_title],
        ['Company', row.company_name],
    ]);
}

const renderCustomer = (row) => {
    const names = customerNames(row);
    const details = names.length > 1 ? buildDetailsText([['Customers', names.join(', ')]]) : '';
    return renderWithDetails(row.customer_name || names[0], details);
};

const renderStatus = (row) => {
    return (
        <StatusChip tone={row.is_active ? 'green' : 'grey'}>
            {row.is_active ? 'Active' : 'Inactive'}
        </StatusChip>
    );
};

export const userColumns = [
    { label: 'First name', key: 'firstName', render: (row) => orDash(row.firstName) },
    { label: 'Surname', key: 'lastName', render: (row) => orDash(row.lastName) },
    { label: 'Username', key: 'userName', render: (row) => renderWithDetails(row.userName, buildUserDetails(row)) },
    { label: 'Customer', key: 'customer_name', render: renderCustomer },
    { label: 'Project', key: 'project_name', render: (row) => orDash(row.project_name) },
    {
        label: 'Programme',
        key: 'programme_type_label',
        render: row => orDash([
            row.programme_type_label,
            row.programme_subtype_label,
        ].filter(Boolean).join(' · ')),
    },
    { label: 'Role', key: 'role', render: (row) => formatRole(row.role) },
    { label: 'Created', key: 'created_at', render: (row) => renderTableDate(row.created_at) },
    { label: 'Status', key: 'is_active', render: renderStatus },
    { label: 'Email', key: 'email', render: (row) => orDash(row.email) },
    { label: 'Contact', key: 'contact_no', render: (row) => orDash(row.contact_no) },
    { label: 'Action', key: 'action', actions: ['edit'] },
];
